import { render, staticRenderFns } from "./BlockFeedbackForm.vue?vue&type=template&id=c2617678"
import script from "./BlockFeedbackForm.vue?vue&type=script&lang=js"
export * from "./BlockFeedbackForm.vue?vue&type=script&lang=js"
import style0 from "./BlockFeedbackForm.vue?vue&type=style&index=0&id=c2617678&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports